import { render } from "./ButtonDelete.vue?vue&type=template&id=09fcc8ca&ts=true"
import script from "./ButtonDelete.vue?vue&type=script&lang=ts"
export * from "./ButtonDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__